import { LangCode } from "@/lib/gql/__generated__/graphql";

import type { DayOfWeekArrayType } from "./types";

/**
 * 曜日の配列を取得する
 */
export function createDayOfWeekArray(lang = LangCode.Default): DayOfWeekArrayType {
	switch (lang) {
		case LangCode.Default: {
			return ["日", "月", "火", "水", "木", "金", "土"];
		}
		case LangCode.En: {
			return ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
		}
	}
}
